import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-muted2" data-testid="auth-loading">
        Verifying session…
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
}
